import React from 'react';
import { groupBy } from 'lodash';
import { Seat } from '../../model/seatmap/types';

interface Props {
  seats: Seat[];
}

export function GroupedSeats({ seats }: Props): JSX.Element {
  const groups = groupBy(seats, 'section.name');
  return (
    <div className="edit-box__seats">
      {Object.keys(groups)
        .sort()
        .map((key) => {
          return <div key={key}>{`${key}: ${groups[key].length}`}</div>;
        })}
    </div>
  );
}
